// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__SBbx5","value":"StatCard_value__opya6","label":"StatCard_label__eLxg-","accent":"StatCard_accent__VVjHr","danger":"StatCard_danger__KfiIB"};